import { InfoCircleOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FAQButton = ({ navigateLink = '/virtual-engineer/faq' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <Button
      icon={location.pathname === navigateLink ? <ArrowLeftOutlined /> : <InfoCircleOutlined />}
      size='large'
      style={{ border: 'none' }}
      className='infoButton'
      onClick={() => {
        if (location.pathname === navigateLink) {
          navigate(-1);
        } else navigate(navigateLink);
      }}
    >
      {location.pathname === navigateLink ? t('back') : 'FAQ'}
    </Button>
  );
};

export default FAQButton;
